/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeSourcesRequest
 */
export interface MergeSourcesRequest {
    /**
     * The ID of the source that survives the merge
     */
    source_to_keep_id: string;
}

/**
 * Check if a given object implements the MergeSourcesRequest interface.
 */
export function instanceOfMergeSourcesRequest(value: object): value is MergeSourcesRequest {
    if (!('source_to_keep_id' in value) || value['source_to_keep_id'] === undefined) return false;
    return true;
}

export function MergeSourcesRequestFromJSON(json: any): MergeSourcesRequest {
    return MergeSourcesRequestFromJSONTyped(json, false);
}

export function MergeSourcesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeSourcesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'source_to_keep_id': json['source_to_keep_id'],
    };
}

export function MergeSourcesRequestToJSON(json: any): MergeSourcesRequest {
    return MergeSourcesRequestToJSONTyped(json, false);
}

export function MergeSourcesRequestToJSONTyped(value?: MergeSourcesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source_to_keep_id': value['source_to_keep_id'],
    };
}

